module.exports = __webpack_public_path__ + "img/sp_full.ecf08826.jpg";